// Local storage polyfill
// No tests needed, it just works. Trust me i'm a developer...
// Alex Foster 2018

import Cookies from '../Cookies';

((ctrl, cookie) => {
  const hasLocalStorage = () => {
    try {
      ctrl.localStorage.setItem('foo', 'bar');
      ctrl.localStorage.removeItem('mod');
      return true;
    } catch (e) {
      return false;
    }
  };

  if (!hasLocalStorage()) {
    const defaults = { expires: 365, path: '' };

    const keyFormer = (...args) => args.join('-');

    const safeParse = data => {
      try {
        return JSON.parse(data);
      } catch (err) {
        return data;
      }
    };

    const storage = session => {
      const getItem = key => {
        const retrieve = (i = 0) => {
          const data = cookie.get(keyFormer(session, key, i));
          if (data) {
            const next = retrieve(i + 1);
            if (next) {
              return data + next;
            }
            return data;
          }
          return null;
        };
        return safeParse(retrieve());
      };

      const removeItem = key => {
        const destroy = (i = 0) => {
          const data = cookie.get(keyFormer(session, key, i));
          if (data) {
            cookie.remove(keyFormer(session, key, i), defaults);
            return destroy(i + 1);
          }
          return null;
        };
        return destroy();
      };

      const setItem = (key, value) => {
        const encoded = JSON.stringify(value);
        const chunks = encoded.match(/.{1,3000}/g);
        chunks.forEach((chunk, i) => {
          cookie.set(keyFormer(session, key, i), chunk, defaults);
        });
      };

      return {
        clear: () => true,
        key: () => null,
        getItem,
        removeItem,
        setItem,
      };
    };

    Object.defineProperty(ctrl, 'localStorage', { value: storage('local') });
    Object.defineProperty(ctrl, 'sessionStorage', { value: storage('session') });
  }
})(window, Cookies);
